import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_versions_dynamic_view = _resolveComponent("versions-dynamic-view")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			'hd-mod-header',
			{ 'is-ready': _ctx.ready }
		])
  }, [
    _createVNode(_component_versions_dynamic_view, null, {
      galaxy: _withCtx(() => [
        _createVNode(_component_base_button, {
          callback: _ctx.processOverlay,
          callbackString: "References",
          class: "crux-click",
          "data-crux": "citations-handle",
          modifier: "light",
          "data-analytics-name": "citations",
          "data-analytics-id": "references"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lyra_asset, { "asset-key": "app-link-button-references" })
          ]),
          _: 1
        }, 8, ["callback"])
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass([
				'hd-mod-header-navigation',
				{ 'is-ready': _ctx.ready }
			])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([
					'hd-mod-header-navigation__item',
					'hd-mod-header-navigation__item--previous',
					{ 'is-disabled': _ctx.frameStatus === 'start' },
					'analytics-click'
				]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateToFrame(-1))),
        "data-analytics-name": "mod",
        "data-analytics-id": "previous"
      }, [
        _createVNode(_component_base_image_svg, {
          class: "hd-mod-header-navigation__item-icon",
          source: require('!html-loader!../assets/icons/down-arrow.svg')
        }, null, 8, ["source"]),
        _createVNode(_component_lyra_asset, { "asset-key": "app.previous" })
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([
					'hd-mod-header-navigation__item',
					'hd-mod-header-navigation__item--next',
					{ 'is-disabled': _ctx.frameStatus === 'end' },
					'analytics-click'
				]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToFrame(1))),
        "data-analytics-name": "mod",
        "data-analytics-id": "next"
      }, [
        _createVNode(_component_base_image_svg, {
          class: "hd-mod-header-navigation__item-icon",
          source: require('!html-loader!../assets/icons/down-arrow.svg')
        }, null, 8, ["source"]),
        _createVNode(_component_lyra_asset, { "asset-key": "app.next" })
      ], 2)
    ], 2)
  ], 2))
}